module.exports = __webpack_public_path__ + "static/img/classified.6a5b21e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/graphics/classified.png
// module id = x3xq
// module chunks = 1